<template>
  <div>
    <footer class="">
      <section  v-if="require('../router/routerSetting').getLanguage() === 'tw'">
        <div class="container py-lg-5 py-md-5 py-sm-4 py-4">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12">
              <h4 class="pb-2">與我們聯繫</h4>
              <div class="footer-icons">
                <ul>
                  <li class="mb-2"><a href="https://lin.ee/CnMkiqh" target="_blank" rel="noopener noreferrer">裕融企業 LINE 官方帳號</a></li>
                  <li class="mb-2">客服專線(市話直撥) 0800-367-367</li>
                  <li class="mb-2">客服專線(手機請撥) 02-2702 5055轉2</li>
                  <li class="mb-2">客服(申訴)信箱 <a href="https://www.tac.finance/Home/search_content#nav-profile">service@tac.com.tw</a></li>
                  <li class="mb-2">申訴專線 02-7704 7267</li>
                </ul>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-12">
              <h4 class="pb-2">關係企業</h4>
              <nav class="border-line">
                <ul class="nav">
                  <li class="classification">台灣</li>
                    <li v-for="item in taiwan" :key="item.name">
                      <a :href="item.href" target="_blank">{{ item.name }}</a>
                    </li>
                </ul>
                <ul class="nav">
                    <li class="classification">大陸</li>
                    <li v-for="item in china" :key="item.name">
                      <a :href="item.href" target="_blank">{{ item.name }}</a>
                    </li>
                </ul>
                <ul class="nav">
                    <li class="classification">東南亞</li>
                    <li v-for="item in southeastAsia" :key="item.name">
                      <a :href="item.href" target="_blank">{{ item.name }}</a>
                    </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>
      <div class="copyright text-center">
          <p>{{copyright}}</p>
      </div>
    </footer>
    <a href="#" id="gotop">
        <i class="fa fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>
  footer nav ul {
    padding-bottom: .3em;
  }
  nav .classification {
    padding-right: 1rem;
    letter-spacing: .1em;
    font-weight: bold;
  }
</style>

<script>
import $ from 'jquery'
  $(function() {
      /* 按下GoTop按鈕時的事件 */
      $('#gotop').click(function(){
          $('html,body').animate({ scrollTop: 0 }, 'slow');   /* 返回到最頂上 */
          return false;
      });
      
      /* 偵測卷軸滑動時，往下滑超過400px就讓GoTop按鈕出現 */
      $(window).scroll(function() {
          if ( $(this).scrollTop() > 400){
              $('#gotop').fadeIn();
          } else {
              $('#gotop').fadeOut();
          }
      });
  });
export default {
  name: 'my-footer',
  data () {
    return {
      taiwan: [
        // {
        //   name: '裕融企業',
        //   href: 'https://www.tac.finance/Home/Carloan'
        // },
        {
          name: '新鑫公司',
          href: 'https://www.shincredit.com.tw/'
        },
        {
          name: '裕富數位',
          href: 'https://www.yurich.com.tw/'
        },
        {
        name: '新鑫電力',
        href: 'https://www.shinenergy.com.tw/'
        },
        {
        name: '格上租車',
        href: 'https://www.car-plus.com.tw/'
        },
        {
        name: '裕電俥電',
        href: 'https://www.yes-charging.com.tw/'
        },
        {
        name: '行冠企業',
        href: 'https://tw.molife.com/M_Molife/'
        },
        {
        name: '觔斗雲聯網科技(LINE GO)',
        href: 'https://www.linego.me/'
        },
        
        // {
          // name: '裕國融資(杭州)',
          // href: 'http://www.tacfinance.cn/'
        // },
        
      ],
    china: [
        {
          name: '江蘇裕融融資租賃',
          href: 'https://www.tacleasing.cn/index.html'
        },        
        {
          name: '格上租賃(蘇州)',
          href: 'http://www.car-plus.com.cn/'
        },
        {
          name: '格上租賃(上海)',
          href: 'http://www.car-plus.com.cn/'
        }
      ],
      southeastAsia: [
        {
          name: '裕隆金融(菲律賓)',
          href: 'https://www.yulon-finance.com.ph/'
        },
        {
          name: '裕隆金融(馬來西亞)',
          href: 'https://www.yulon-capital.com.my/'
        }
      ],
      copyright: '©'+ new Date().getFullYear() +' All Rights Reserved | Design by Taiwan Acceptance Corporation'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue